import { render } from "./CutScreen.vue?vue&type=template&id=da3f7670&scoped=true&ts=true"
import script from "./CutScreen.vue?vue&type=script&lang=ts"
export * from "./CutScreen.vue?vue&type=script&lang=ts"

import "./CutScreen.vue?vue&type=style&index=0&id=da3f7670&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3f7670"]])

export default __exports__